import { createContext } from "react";

const AllPropertiesContext = createContext();

export default AllPropertiesContext;
